<template>
  <div class="hero">
    <div class="relative z-10">
      <div class="window">
        <div class="relative flex items-center h-5 bg-gray-200 rounded-t">
          <div class="absolute top-0 left-0 flex items-center h-5 h-full ml-2 space-x-1">
            <div class="w-2 h-2 bg-gray-400 rounded-full"></div>
            <div class="w-2 h-2 bg-gray-400 rounded-full"></div>
            <div class="w-2 h-2 bg-gray-400 rounded-full"></div>
          </div>
          <div class="w-1/2 h-3 mx-auto rounded bg-gray-50"></div>
        </div>
        <img src="/images/ui/booking-form.png" alt="" class="rounded-b">
      </div>

      <div class="chart">
        <div class="origin-bottom-right transform scale-75 bg-white rounded-lg shadow-lg">
          <sparkline 
            title="Orders Per Day"
            color="#6775F5"
            :series="data"
            :change="151"
            :total="{ primary: 320, secondary: 216 }"
            start="Jan"
            end="Dec"
            :format="val => `${val}`"
             />
        </div>
      </div>

      <div class="alert">
        <div class="relative px-6 pt-6 pb-4 overflow-hidden text-center rounded-lg shadow-lg bg-gray-50">
          <div class="flex items-center justify-center w-8 h-8 mx-auto text-gray-500 bg-gray-500 bg-opacity-25 rounded-full">
            <fa :icon="['fas', 'inbox-in']" />
          </div>
          <div class="mt-2 text-xs text-gray-900 opacity-75">
            <strong>New Order Placed</strong>
            <br>
            5 New Orders
            <br>
            18 Today Total
          </div>
        </div>
      </div>

      <div class="reminder">
        <div class="relative rounded-lg shadow-lg bg-gray-50">
          <div class="flex items-center">
            <div class="p-3 text-gray-500 bg-gray-200 rounded-l-lg">
              <fa :icon="['fas', 'bell']" />
            </div>
            <div class="px-4 py-2 leading-none ">
              <div class="text-xs font-bold tracking-wider uppercase">
                ORDER ETA
              </div>
              <div class="text-xs">
                Your driver should arrive in 22 minutes.
              </div>
            </div>
          </div>
        </div>
        <div class="relative mt-4 rounded-lg shadow-lg opacity-75 bg-gray-50">
          <div class="flex items-center">
            <div class="p-3 text-gray-500 bg-gray-200 rounded-l-lg">
              <fa :icon="['fas', 'exclamation-circle']" />
            </div>
            <div class="px-4 py-2 leading-none ">
              <div class="text-xs font-bold tracking-wider uppercase">
                Proof of Delivery
              </div>
              <div class="text-xs">
                Order Completed at {{ new Date().toLocaleTimeString().substr(0, 5) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="absolute z-0 w-full transform scale-95 -translate-x-1/2 -translate-y-1/2 rounded-full left-1/2 top-1/2" style="padding-top:100%;">
      <div class="absolute top-0 w-full h-full transform scale-100 border-2 border-white rounded-full opacity-25"></div>
      <div class="absolute top-0 w-full h-full transform scale-75 border-white rounded-full opacity-25 border-3"></div>
      <div class="absolute top-0 w-full h-full transform scale-50">
        <div class="w-full h-full bg-white rounded-full opacity-25 animate-ping"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Sparkbar from '@/components/Sparkbar'
import Sparkline from '@/components/Sparkline'

export default {
  name: 'HomepageHero',

  components: {
    Sparkbar,
    Sparkline
  },

  data () {
    return {
      data: [
        {
          name: 'Orders Per Month',
          data: [
            { x: '2019-01-01', y: 220 * 3 },
            { x: '2019-02-02', y: 200 * 3 },
            { x: '2019-03-03', y: 210 * 3 },
            { x: '2019-04-04', y: 190 * 3 },
            { x: '2019-05-05', y: 190 * 3 },
            { x: '2019-06-06', y: 200 * 3 },
            { x: '2019-07-07', y: 230 * 3 },
            { x: '2019-08-08', y: 240 * 3 },
            { x: '2019-09-09', y: 290 * 3 },
            { x: '2019-10-10', y: 310 * 3 },
            { x: '2019-11-11', y: 300 * 3 },
            { x: '2019-12-12', y: 320 * 3 }
          ]
        },
        {
          name: 'Orders Per Day',
          data: [
            { x: '2020-12-12', y: 90 * 3 },
            { x: '2020-11-11', y: 80 * 3 },
            { x: '2020-10-10', y: 100 * 3 },
            { x: '2020-09-09', y: 130 * 3 },
            { x: '2020-08-08', y: 120 * 3 },
            { x: '2020-07-07', y: 140 * 3 },
            { x: '2020-06-06', y: 170 * 3 },
            { x: '2020-05-05', y: 160 * 3 },
            { x: '2020-04-04', y: 180 * 3 },
            { x: '2020-03-03', y: 200 * 3 },
            { x: '2020-02-02', y: 190 * 3 },
            { x: '2020-01-01', y: 210 * 3 }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
  .hero {
    @apply relative py-16;
    transform:perspective(1000px) rotateY(-15deg) scale(1.3);
  }
  
  .window {
    padding-bottom:56%;
    
    img {
      @apply absolute;
    }
  }
  
  .chart, .reminder, .alert, .radar {
    @apply absolute transform;
  }

  .chart {
    @apply bottom-0 right-0 translate-x-10 translate-y-10;
  }

  .reminder {
    @apply top-0 right-0 translate-x-8 -translate-y-5;
  }

  .alert {
    @apply bottom-0 left-0 -translate-x-10 translate-y-8;
  }
</style>